import api from 'core/util/api';
import { EventsAppProtocols } from '@kentik/ui-shared/dictionary/types';
import { UseQueryOptions } from '@tanstack/react-query';

const queryFn = () => api.get('/api/ui/dictionary/eventsAppProtocols') as Promise<EventsAppProtocols>;

export const eventsAppProtocolsQuery = {
  queryKey: ['eventsAppProtocolsRaw'] as const,
  queryFn,
  staleTime: 300000
} as const satisfies UseQueryOptions<EventsAppProtocols, Error, EventsAppProtocols, readonly ['eventsAppProtocolsRaw']>;
